import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import WidgetWithChart from 'components/kea/widgets/common/WidgetWithChart';
import IntlMessages from '../../../../util/IntlMessages';

const valueOrDash = (value) => {
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric.toLocaleString() : '—';
};

const Summary = ({ summary }) => {
  const dataMetrics = [
    {
      id: 'uniqueVisitors',
      title: valueOrDash(summary.totalCarts),
      subTitle: <IntlMessages id="dashboard.metrics.uniqueVisitors" />,
      tone: 'searches',
    }, {
      id: 'viewedProducts',
      title: valueOrDash(summary.totalViews),
      subTitle: <IntlMessages id="dashboard.metrics.viewedProducts" />,
      tone: 'clickEvents',
    }, {
      id: 'searchSessions',
      title: valueOrDash(summary.totalSearchSessions),
      subTitle: <IntlMessages id="dashboard.metrics.searchSessions" />,
      tone: 'clickRate',
    }, {
      id: 'actionsRate',
      title: Number.isFinite(Number(summary.actionsPercentage)) ? `${Number(summary.actionsPercentage).toLocaleString()}%` : '—',
      subTitle: <IntlMessages id="dashboard.metrics.actionsRate" />,
      tone: 'lostOpportunities',
    },
  ];

  return dataMetrics.map((metric) => (
    <Grid item xs={12} sm={6} lg={3} key={metric.id}>
      <WidgetWithChart
        title={metric.subTitle}
        mainNumber={metric.title}
        description={metric.subTitle}
        tone={metric.tone}
      />
    </Grid>
  ));
};

export default Summary;

Summary.propTypes = {
  summary: PropTypes.shape({
    totalCarts: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    totalViews: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    totalSearchSessions: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    actionsPercentage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
};
